module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_5012.82599fde.png";